var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJourney = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 23,
    viewBox: "0 0 23 23",
    width: 23,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#15206b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.3503 10.5933-6.61104 6.6008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.124 4.88818c1.9097 1.33986 3.5716 3.00171 4.9116 4.9112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.954 13.8145v2.9224c-.0001.115-.0233.2288-.0682.3346-.0449.1059-.1106.2018-.1932.2818l-2.6238 2.6235c-.054.0559-.122.096-.197.1163-.0749.0203-.1539.0199-.2286-.0011-.0747-.0211-.1423-.0622-.1957-.1186-.0533-.0564-.0903-.1262-.1071-.2019l-.775-3.2774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.0263 7.68933.5883-2.80106c.0428-.21143.0326-.43012-.0297-.63667-.0622-.20654-.1747-.39454-.3272-.54708-.1526-.15254-.3405-.26484-.5471-.32711-.2065-.06226-.4253-.07244-.6367-.02963l-2.8013.58811c-1.6883.35009-3.2369 1.1877-4.454 2.40899l-2.18495 2.17533c-1.20742 1.21183-1.99312 2.77989-2.24102 4.47239v.2241c-.06126.4023-.02631.8134.1019 1.1997.12822.3862.3461.7367.6358 1.0226l.45753.4575c.28619.286.63546.5008 1.01981.6273.38434.1265.79304.1611 1.19317.101h.22406c1.697-.2492 3.2685-1.0384 4.482-2.2504l2.1757-2.1753c1.2017-1.2444 2.016-2.8112 2.3437-4.50977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.11884 7.98828h-2.91328c-.23068.00799-.4502.10115-.61625.26147l-2.63317 2.63295c-.05293.0552-.09054.1232-.10908.1974s-.01734.1521.00342.2257.06038.1404.11495.194c.05457.0535.1222.0918.19617.1112l3.28674.7751"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJourney);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/journey.e2ea8cacb4dcbfa9b742fca580e8e6d3.svg";